import { Icon } from "@fluentui/react/lib/Icon";
import { Button, Tooltip } from "antd";

interface TooltipButtonProps {
  iconName: string;
  text: string;
  onClick: () => void;
  disabled?: boolean | undefined;
  loading?: boolean | undefined;
  type: "primary" | "secondary" | "dark";
  id?: string;
}
export default function TooltipButton({ iconName, text, disabled, onClick, loading, type, id }: TooltipButtonProps) {
  return (
    <Tooltip title={text}>
      <Button
        className={`media-btn ${type}`}
        id={id}
        loading={loading ? loading : false}
        disabled={disabled}
        onClick={() => {
          if (!disabled) {
            onClick();
          }
        }}>
        {!loading && <Icon iconName={iconName} />}
      </Button>
    </Tooltip>
  );
}
